import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Button from 'components/Button'

import {POLICY_DETAIL_URL } from 'constants'

import PolicyForm from 'components/PolicyForm'

import { statusChanged } from 'components/RequestStatus/actions'
import { importExtraData } from 'scenes/VehicleDetail/components/Policy/actions'
import { refreshPolicy } from 'scenes/VehicleDetail/actions'

export class NewPolicy extends BaseComponent {

  constructor() {
    super()

    this.state = {
      buttonProps: {}
    }

    this._bind('_renderPolicyFormFooter', '_onError', '_onSuccess', '_submitForm')
  }

  _onError() {
    this.setState({
      buttonProps: {}
    })
  }

  _onSuccess(policyId) {
    this.props.updateRequestStatus('progress', 'Renovando Póliza')
    const props = this.props
    request(POLICY_DETAIL_URL(props.userId, props.vehicleId, policyId))
      .then((res) => {
        this.context.hideModal()
        this.props.updateRequestStatus('ok', 'Póliza renovada')
        this.props.refreshPolicy()
        this.props.importExtraData()
        this.props.refreshExtraData()
      })
      .catch(console.log)
  }

  _submitForm(submitForm) {
    // this is not the most optimum since this fn its invoked
    // on each update
    return (evt) => {
      evt.preventDefault()
      this.setState({
        buttonProps: { disabled: true }
      })
      submitForm()
    }
  }

  _renderPolicyFormFooter(submitForm) {
    return (
      <div className="controls">
        <p><span>IMPORTANTE:</span> Al crear la renovación de póliza se desactivará de manera automática la póliza actual.</p>
        <Button
          onClick={this._submitForm(submitForm)}
          {...this.state.buttonProps}
        >
          Renovar póliza
        </Button>
      </div>
    )
  }

  render() {
    const data = this.props.extra_data
    return (
      <div id="NewPolicy" className="EditModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>Renovación de póliza</h1>
          <span className="material-icons close-button" onClick={this.context.hideModal}>clear</span>
        </div>
        <PolicyForm
          renderFooter={this._renderPolicyFormFooter}
          onError={this._onError}
          onSuccess={this._onSuccess}
          clientId={this.props.userId}
          vehicleId={parseInt(this.props.vehicleId, 10)}
          ref={(form) => this.policyForm = form}
          extraData={data}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    extra_data: state.policyVehicleDetail.get('extra_data').toJS(),
    extra_data_order: state.policyVehicleDetail.get('extra_data_order').toArray()
  }
}

NewPolicy.contextTypes = {
  hideModal: PropTypes.func.isRequired
}

NewPolicy.propTypes = {
  userId: PropTypes.string.isRequired,
  vehicleId: PropTypes.string.isRequired,
  policyId: PropTypes.number.isRequired
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    refreshPolicy: () => dispatch(refreshPolicy()),
    importExtraData: () => dispatch(importExtraData([])),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewPolicy)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Policy/PolicyData/NewPolicy.js